export function gain_produce(pid) {
	if (pid) {

		let temp_produce = false;
		for (let i in produce) {
			if (produce[i]['p_id'] === pid) {
				temp_produce = produce[i];
				break;
			}
		}

		switch (temp_produce['p_id']) {
			//标准房卡套
			case 'pidcards_hbfkt': {
				temp_produce['table'] = createPid_hbfkt();
				break;
			}
			//标准封套
			case 'pidcards_hbft': {
				temp_produce['table'] = createPid_hbft();
				break;
			}
			//专版筷子套
			case 'pidcards_zbkzt': {
				temp_produce['table'] = createPid_zbkzt();
				break;
			}
			//专版封套
			case 'pidcards_zbft': {
				temp_produce['table'] = createPid_zbft();
				break;
			}
			//
			case 'pidcards_tjbg': {
				temp_produce['table'] = createPid_tjbg();
				break;
			}
			//电脑打印联单
			case 'pidcards_pcliandan': {
				temp_produce['table'] = createPid_pcliandan();
				break;
			}
			//无碳联单
			case 'pidcards_wtliandan': {
				temp_produce['table'] = createPid_wtliandan();
				break;
			}
			//珠光纸烫金信封
			case 'pidcards_gdty': {
				temp_produce['table'] = createPid_gdty();
				break;
			}
			//会计用品
			case 'pidcards_kjyp': {
				temp_produce['table'] = createPid_kjyp();
				break;
			}
			//快递封
			case 'pidcards_kuaidifeng': {
				temp_produce['table'] = createPid_kuaidifeng();
				break;
			}
			//标准档案盒
			case 'pidcards_bzdah': {
				temp_produce['table'] = createPid_bzdah();
				break;
			}
			//便笺表格
			case 'pidcards_bzbg': {
				temp_produce['table'] = createPid_bzbg();
				break;
			}
			//白卡盒
			case 'pidcards_baikahe': {
				temp_produce['table'] = createPid_baikahe();
				break;
			}
		}

		return temp_produce;
	}
}

const produce = [
	{ p_id: 'pidcards_hbfkt', choose: false, p_name: '标准房卡套' },
	{ p_id: 'pidcards_hbkzt', choose: false, p_name: '标准筷子套' },
	{ p_id: 'pidcards_hbft', choose: false, p_name: '标准封套' },
	{ p_id: 'pidcards_zbfkt', choose: false, p_name: '专版房卡套' },
	{ p_id: 'pidcards_zbkzt', choose: false, p_name: '专版筷子套' },
	{ p_id: 'pidcards_zbft', choose: false, p_name: '专版封套' },
	{ p_id: 'pidcards_tjbg', choose: false, p_name: '体检报告' },
	{ p_id: 'pidcards_pcliandan', choose: false, p_name: '电脑打印联单' },
	{ p_id: 'pidcards_wtliandan', choose: false, p_name: '无碳联单' },
	{ p_id: 'pidcards_gd', choose: false, p_name: '高端现货信封' },
	{ p_id: 'pidcards_gdty', choose: false, p_name: '珠光纸烫金信封' },
	{ p_id: 'pidcards_kjyp', choose: false, p_name: '会计用品' },
	{ p_id: 'pidcards_kuaidifeng', choose: false, p_name: '快递封' },
	{ p_id: 'pidcards_bzdah', choose: false, p_name: '标准档案盒' },
	{ p_id: 'pidcards_bzbg', choose: false, p_name: '便笺表格' },
	{ p_id: 'pidcards_baikahe', choose: false, p_name: '白卡盒' },
]
// 白卡盒
function createPid_baikahe() {
	return {
		p_cailiao: {
			name: '盒型',
			container: ['parentid', 'caitype'],
			data_multi: [
				{
					type: 'select', name: '双插盒', value: '0', choose: true, level: '1', select_show: false, select_data: [
						{ name: '双插盒', value: '0', src: "1" },
						{ name: '扣底盒', value: '1', src: "2" },
					]
				},
				{
					type: 'select', name: '普通', value: '1', choose: true, level: '2', select_show: false, select_data: [
						{ name: '普通', value: '1', src: "1" },
						{ name: '带安全扣', value: '2', src: "4" },
						{ name: '带挂钩', value: '3', src: "5" },
						{ name: '同边', value: '5', src: "6" },
					]
				},
			],
			multi_list: [
				// 双插盒
				[
					{ name: '普通', value: '1', src: "1" },
					{ name: '带安全扣', value: '2', src: "4" },
					{ name: '带挂钩', value: '3', src: "5" },
					{ name: '同边', value: '5', src: "6" },
				],
				// 扣底盒
				[
					{ name: '普通', value: '8', src: "7" },
					{ name: '带安全扣', value: '9', src: "8" },
					{ name: '带挂钩', value: '10', src: "9" },
					{ name: 'L型', value: '26', src: "10" },
				],
			]
		},
		p_chengpinchicun: {
			name: '尺寸',
			container: ['x', 'y', 'z'],
			data: [
				{ type: 'custom4', name: '', value: [100, 80, 120, '250*83', '展开尺寸:250×83'], choose: true },
				{ type: 'custom2', name: '展开尺寸', value: [250, 83, '250*83', '展开尺寸:250×83'], choose: false },
			]
		},
		p_yinshuashuliang: {
			name: '印刷数量',
			container: 'shuliang',
			data: [
				{ type: 'custom1', name: ' ', value: 10000, unit: '', choose: true, },
			]
		},
		// 纸张
		p_zhizhang: {
			name: '纸张',
			container: ['cailiao', 'yongzhi'],
			data_multi: [
				{
					type: 'select', name: '单铜纸(白卡)', value: '2', choose: true, level: '1', select_show: false, select_data: [
						{ name: '单铜纸(白卡)', value: '2' },
					]
				},
				{
					type: 'select', name: '350克', value: 350, choose: true, level: '2', select_show: false, select_data: [
						{ name: '190克', value: 190 },
						{ name: '210克', value: 210 },
						{ name: '230克', value: 230 },
						{ name: '250克', value: 250 },
						{ name: '300克', value: 300 },
						{ name: '350克', value: 350 },
						{ name: '400克', value: 400 },
					]
				},
			],
			multi_list: [
				[
					{ name: '190克', value: 190 },
					{ name: '210克', value: 210 },
					{ name: '230克', value: 230 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
					{ name: '400克', value: 400 },
				],
			]
		},
		p_yinshuayanse: {
			name: '印刷颜色',
			container: 'ysys',
			data: [
				{ type: 'default', name: '彩色', value: '4', choose: true },
			]
		},
		p_biaomianchuli: {
			name: '表面处理',
			container: 'bmcl',
			data: [
				{ type: 'default', name: '无', value: '无', choose: true },
				{ type: 'default', name: '覆亮膜', value: '覆亮膜', choose: false },
				{ type: 'default', name: '覆哑膜', value: '覆哑膜', choose: false },
				{ type: 'default', name: '过光油', value: '过光油', choose: false },
				{ type: 'default', name: '过哑油', value: '过哑油', choose: false },
				{ type: 'default', name: '触感膜', value: '触感膜', choose: false },
				{ type: 'default', name: '镭射膜', value: '镭射膜', choose: false },
			]
		},
		//后道工序
		p_houdaogongxu: {
			name: "后道工序",
			data_after: [
				{
					container: "hjg",
					must: true,
					reduce: true, //缩小排放
					data: [
						{
							type: "default",
							name: "模切",
							value: "模切",
							choose: true,
						},
					],
				},
				{
					container: "hjg",
					must: true,
					reduce: true,
					data: [
						{
							type: "default",
							name: "粘",
							value: "粘盒",
							choose: true,
						},
						//   {
						// 	type: "default",
						// 	name: "粘两道",
						// 	value: "粘两道",
						// 	choose: false,
						//   },
					],
				},
				{
					container: ["tjx", "tjy", "hjg"],
					must: false,
					data: [
						{
							type: "select",
							custom2: true,
							unit: "mm",
							name: "烫黄金",
							value: [10, 10, "烫金"],
							choose: false,
							select_show: false,
							select_data: [
								{ name: "烫黄金", value: [10, 10, "烫金"] },
								{ name: "烫银", value: [10, 10, "烫金"] },
								{ name: "烫红金", value: [10, 10, "烫金"] },
								{ name: "烫哑金", value: [10, 10, "烫金"] },
								{ name: "烫蓝金", value: [10, 10, "烫金"] },
								{ name: "烫黑金", value: [10, 10, "烫金"] },
								{ name: "烫指定颜色金", value: [10, 10, "烫金"] },
							],
						},
					],
				},
				{
					container: ["jtx", "jty", "hjg"],
					must: false,
					data: [
						{
							type: "custom2",
							name: "击凸",
							value: [10, 10, "击凸"],
							choose: false,
						},
					],
				},
				{
					container: "hjg",
					must: false,
					data: [
						{
							type: "default",
							name: "压纹",
							value: "压纹",
							choose: false,
						},
					],
				},
				{
					container: ['jpx', 'jpy', 'hjg'],
					must: false,
					data: [
						{ type: 'custom2', name: '开窗贴膜', value: [10, 10, '开天窗贴胶片'], choose: false },
					]
				},
				{
					container: ['uvx', 'uvy', 'hjg'],
					must: false,
					data: [
						{ type: 'custom2', name: '局部UV', value: [10, 10, '局部UV'], choose: false },
					]
				},
				{
					container: ['shuangmianjiaox', 'shuangmianjiaoy', 'shuangmianjiaohen', 'hjg'],
					must: false,
					data: [
						{ type: 'custom4', name: '贴双面胶', value: [10, 10, 1, '粘双面胶'], choose: false },
					]
				},
			],
		}
	}
}
// 标准房卡套
function createPid_hbfkt() {
	return {
		// 成品尺寸
		p_leixing:{
			name: '产品类型',
			container: 'chanpin',
			data: [
				{ type: 'default', name: '合版房卡套', value: '1', choose: true },
				{ type: 'default', name: '专版房卡套', value: '2', choose: false },

			]
		},
		p_chicun: {
			name: '成品方式',
			container: ['qid', 'isdiy', 'xfys'],
			data: [
				{ type: 'default', name: '口袋式', value: ['11', '1', ''], choose: true },
				{ type: 'default', name: '对折式', value: ['11', '1', ''], choose: false },

			]
		},
		p_chengpinchicun: {
			name: '尺寸',
			container: ['xx', 'yy', 'chichunstr'],
			data: [
				{ type: 'default', name: '直角62*95mm', value: [139, 110, '139*110'], choose: true },
				{ type: 'default', name: '异形62*95mm', value: [139, 110, '139*110'], choose: false },
				{ type: 'custom2', name: '自定义展开尺寸', value: [139, 110, '139*110'], choose: false },
			]
		},
		// 刀模
		p_daomo: {
			name: '刀模',
			container: 'daomo',
			data: [
				{ type: 'default', name: '标准刀模', value: '0', choose: true },
				// { type: 'default', name: '定制刀模', value: '1', choose: false },
			]
		},
		// 单双面
		p_danshuangmian: {
			name: '单双面',
			container: 'danshuang',
			data: [
				// {type:'default', name:'双面', value:'2', choose:true},
				{ type: 'default', name: '单面', value: '1', choose: true },
			]
		},
		// 材料
		p_cailiao: {
			name: '材料',
			container: ['cailiao', 'yongzhi'],
			data_multi: [
				{
					type: 'select', name: '单铜纸(白卡)', value: '2', choose: true, level: '1', select_show: false, select_data: [
						
						{ name: '单铜纸(白卡)', value: '2' },
						// { name: '双胶纸', value: '5' },
						{ name: '双铜纸', value: '1' },
						// { name: '白牛皮', value: '14' },
					]
				},
				{
					type: 'select', name: '250克', value: 250, choose: true, level: '2', select_show: false, select_data: [
						{ name: '250克', value: 250 },
					]
				},
			],
			multi_list: [
				[
					{ name: '250克', value: 250 },
				],
				[
					{ name: '300克', value: 300 },
				],
			]
		},

		// 印刷颜色
		p_yinshuayanse: {
			name: '印刷颜色',
			container: 'ysys',
			data: [
				{ type: 'default', name: '彩色', value: '4', choose: true },
			]
		},


		// 印刷数量
		p_yinshuashuliang: {
			name: '印刷数量',
			container: 'shuliang',
			data: [
				{ type: 'default', name: '500', value: 500, choose: true },
				{ type: 'default', name: '1000', value: 1000, choose: false },
				{ type: 'default', name: '2000', value: 2000, choose: false },
				{ type: 'default', name: '3000', value: 3000, choose: false },
				{ type: 'default', name: '5000', value: 5000, choose: false },
				{ type: 'default', name: '10000', value: 10000, choose: false },
				// { type: 'custom1', name: '', value: 20000, choose: false },
			]
		},
		// 印刷款数
		p_kuanshu: {
			name: '印刷款数',
			container: 'pinzhong',
			data: [
				{ type: 'default', name: '1', value: 1, choose: true, },
				{ type: 'default', name: '2', value: 2, choose: false, },
				{ type: 'default', name: '3', value: 3, choose: false, },
				{ type: 'default', name: '4', value: 4, choose: false, },
				{ type: 'default', name: '5', value: 5, choose: false, },
				{ type: 'default', name: '6', value: 6, choose: false, },
				{ type: 'default', name: '7', value: 7, choose: false, },
				{ type: 'custom1', name: '', value: 9, choose: false, },
			],
		},
		//后道工序
		p_houdaogongxu: {
			name: '后道工序',
			data_after: [
				{
					container: 'hjg',
					must: true,
					reduce: true,
					data: [
						{ type: 'default', name: '模切', value: '模切', choose: true },
					]
				},
				{
					container: 'hjg',
					must: true,
					reduce: true,
					data: [
						{ type: 'default', name: '粘成品', value: '切圆角', choose: true },
					]
				},
				
				{
					container: "bmcl",
					must: true,
					data: [
						{
							type: "select",
							name: "单面哑膜",
							value: "覆哑膜",
							choose: true,
							select_show: false,
							select_data: [
								{ name: "单面哑膜", value: "覆哑膜" },
							],
						},
					],
				},
			]
		}
	}
}

// 标准封套
function createPid_hbft() {
	return {
		// 成品尺寸
		p_chengpinchicun: {
			name: '成品尺寸',
			container: ['xx', 'yy', 'chichunstr'],
			data: [
				{ type: 'default', name: '213*305', value: [213, 305, '213*305'], choose: true },
			]
		},
		// 兜底
		p_doudi: {
			name: '兜底',
			container: 'chichun2',
			data: [
				{ type: 'default', name: '70', value: 70, choose: true },
			]
		},
		// 印刷款数
		p_kuanshu: {
			name: '印刷款数',
			container: 'pinzhong',
			data: [
				{ type: 'default', name: '1', value: 1, choose: true, },
				{ type: 'default', name: '2', value: 2, choose: false, },
				{ type: 'default', name: '3', value: 3, choose: false, },
				{ type: 'default', name: '4', value: 4, choose: false, },
				{ type: 'default', name: '5', value: 5, choose: false, },
				{ type: 'default', name: '6', value: 6, choose: false, },
				{ type: 'default', name: '7', value: 7, choose: false, },
				{ type: 'custom1', name: '', value: 9, choose: false, },
			],
		},
		// 印刷数量
		p_yinshuashuliang: {
			name: '印刷数量',
			container: 'shuliang',
			data: [
				{ type: 'default', name: '200', value: 200, choose: true },
				{ type: 'default', name: '500', value: 500, choose: false },
				{ type: 'default', name: '1000', value: 1000, choose: false },
				{ type: 'default', name: '2000', value: 2000, choose: false },
				{ type: 'default', name: '3000', value: 3000, choose: false },
				{ type: 'default', name: '5000', value: 5000, choose: false },
				{ type: 'custom1', name: '', value: 20000, choose: false },
			]
		},
		// 单双面
		p_danshuangmian: {
			name: '单双面',
			container: 'danshuang',
			data: [
				{ type: 'default', name: '双面', value: '2', choose: true },
			]
		},
		// 材料
		p_cailiao: {
			name: '材料',
			container: 'cailiao',
			data: [
				{ type: 'default', name: '双铜纸250克', value: '双铜纸250克', choose: true },
				{ type: 'default', name: '双铜纸300克', value: '双铜纸300克', choose: false },
			],
		},
		// 印刷颜色
		p_yinshuayanse: {
			name: '印刷颜色',
			container: 'ysys',
			data: [
				{ type: 'default', name: '彩色', value: '彩色', choose: true },
			]
		},
		//后道工序
		p_houdaogongxu: {
			name: '后道工序',
			data_after: [
				{
					container: 'hjg',
					must: true,
					data: [
						{ type: 'default', name: '模切', value: '模切', choose: true },
					]
				},
				{ container: '', must: true, data: [] },
				{
					container: 'hjg',
					must: false,
					data: [
						{ type: 'default', name: '单面亮膜', value: '单面覆亮膜', choose: false },
						{ type: 'default', name: '单面哑膜', value: '单面覆哑膜', choose: false },
					]
				},
				{
					container: 'hjg',
					must: true,
					data: [
						{ type: 'default', name: '粘单底兜', value: '粘单底兜', choose: true },
					]
				},
			]
		}
	}
}

// 专版筷子套
function createPid_zbkzt() {
	return {
		p_chengpinchicun: {
			name: '成品尺寸',
			container: ['xx', 'yy', '', 'chichun', 'chichunstr'],
			data: [
				{
					type: 'select', name: '长款(230X33mm)', value: [242, 81, '', '230X33mm'], choose: true, select_show: false, select_data: [
						{ name: '长款(230X33mm)', value: [242, 81, '', '230X33mm'], choose: true },
						{ name: '短款(190X33mm)', value: [202, 83, '', '190X33mm'], choose: false },
					]
				},
				{ type: 'custom3', name: '自定义展开尺寸', value: [243, 81, '', '243*81', '展开尺寸:243x81'], choose: false },
			]
		},
		// 刀模
		p_daomo: {
			name: '刀模',
			container: 'daomo',
			data: [
				{ type: 'default', name: '标准刀模', value: '0', choose: true },
				// { type: 'default', name: '定制刀模', value: '1', choose: false },
			]
		},
		// 纸张
		p_zhizhang: {
			name: '纸张',
			container: ['cailiao', 'yongzhi'],
			data_multi: [
				{
					type: 'select', name: '双铜纸', value: '1', choose: true, level: '1', select_show: false, select_data: [
						{ name: '双胶纸', value: '5' },
						{ name: '双铜纸', value: '1' },
						{ name: '黄牛皮', value: '9' },
						{ name: '白牛皮', value: '14' },
					]
				},
				{
					type: 'select', name: '157克', value: 157, choose: true, level: '2', select_show: false, select_data: [
						{ name: '128克', value: 128 },
						{ name: '157克', value: 157 },
						{ name: '200克', value: 200 },
					]
				},
			],
			multi_list: [
				// 双胶纸
				[
					{ name: '100克', value: 100 },
					{ name: '120克', value: 120 },
					{ name: '140克', value: 140 },
					{ name: '160克', value: 160 },
				],
				// 双铜纸
				[
					{ name: '128克', value: 128 },
					{ name: '157克', value: 157 },
					{ name: '200克', value: 200 },
				],
				// 黄牛皮
				[
					{ name: '80克', value: 80 },
					{ name: '100克', value: 100 },
					{ name: '120克', value: 120 },
					{ name: '150克', value: 150 },
				],
				// 白牛皮
				[
					{ name: '100克', value: 100 },
					{ name: '120克', value: 120 },
					{ name: '150克', value: 150 },
				],
			]
		},

		// 印刷颜色
		p_yinshuayanse: {
			name: '印刷颜色',
			container: 'ysys',
			data: [
				{ type: 'default', name: '彩色', value: '4', choose: true },
				{ type: 'default', name: '双色', value: '2', choose: false },
				{ type: 'default', name: '单色', value: '1', choose: false },
				{ type: 'default', name: '无', value: '0', choose: false },
			]
		},
		// 印刷数量
		p_yinshuashuliang: {
			name: '印刷数量',
			container: 'shuliang',
			data: [
				{ type: 'default', name: '2000', value: 2000, choose: true },
				{ type: 'default', name: '5000', value: 5000, choose: false },
				{ type: 'default', name: '10000', value: 10000, choose: false },
				{ type: 'default', name: '20000', value: 20000, choose: false },
				{ type: 'default', name: '50000', value: 50000, choose: false },
				{ type: 'default', name: '100000', value: 100000, choose: false },
				{ type: 'custom1', name: '', value: 100000, choose: false },
			]
		},
		//后道工序
		p_houdaogongxu: {
			name: '后道工序',
			data_after: [
				{
					container: 'hjg',
					must: true,
					reduce: true,
					data: [
						{ type: 'default', name: '模切', value: '模切', choose: true },
					]
				},
				{
					container: 'hjg',
					must: true,
					reduce: true,
					data: [
						{ type: 'default', name: '粘', value: '粘成品', choose: true },
					]
				},
				{ container: '', must: true, data: [] },
				{
					container: 'hjgzdy0',
					must: false,
					data: [
						{ type: 'default', name: '过光油', value: '4217', choose: false },
					]
				},
				{
					container: ["tjx", "tjy", "tangCl", "hjg"],
					must: false,
					data: [
						{
							type: "select",
							custom2: true,
							unit: "mm",
							name: "普通平烫",
							value: [150, 150, "25552", "烫金"],
							choose: false,
							select_show: false,
							select_data: [
								{
									name: "普通平烫",
									value: [150, 150, "25552", "烫金"],
								},
								{
									name: "浮雕烫",
									value: [150, 150, "25551", "烫金"],
								},
							],
						},
					],
				},
				{
					container: "tjys",
					must: false,
					data: [
						{
							type: 'select', name: '烫黄金', value: '烫金', choose: false, select_show: false, select_data: [
								{ name: "烫黄金", value: "烫金" },
								{ name: "烫哑金", value: "烫金" },
								{ name: "烫红金", value: "烫金" },
								{ name: "烫蓝金", value: "烫金" },
								{ name: "烫黑金", value: "烫金" },
								{ name: "烫银", value: "烫金" },
								{ name: "烫特殊颜色金", value: "烫金" },
							]
						}
					]
				},
				{
					container: ["texthjgzdyx6", "texthjgzdyy6", "hjgzdy6"],
					must: false,
					data: [
						{ type: 'custom2', name: '局部UV', value: [10, 10, '10494'], choose: false },
					]
				},
				{
					container: 'hjgzdy7',
					must: false,
					data: [
						{ type: 'default', name: '压纹', value: '10495', choose: false },
					]
				},
				{
					container: ["jtx", "jty", "hjg", 'jtCl'],
					must: false,
					data: [
						{
							type: "select",
							custom2: true,
							unit: "mm",
							name: "普通击凸版",
							value: [90, 50, "击凸", "25548"],
							choose: false,
							select_show: false,
							select_data: [
								{ name: "普通击凸版", value: [90, 50, "击凸", "25548"], },
								{ name: "加厚击凸版", value: [90, 50, "击凸", "25549"], },
							],
						},
					],
				},
				{
					container: "bmcl",
					must: false,
					data: [
						{
							type: "select",
							name: "单面亮膜",
							value: "覆亮膜",
							choose: false,
							select_show: false,
							select_data: [
								{ name: "单面亮膜", value: "覆亮膜" },
								{ name: "单面哑膜", value: "覆哑膜" },
								{ name: "单面防刮花哑膜", value: "防刮花哑膜" },
								{ name: "单面触感膜", value: "触感膜" },
								{ name: "单面镭射膜", value: "镭射膜" },
							],
						},
					],
				},
				{
					container: "bmcl",
					must: false,
					data: [
						{
							type: "select",
							name: "单面过光油",
							value: "过光油",
							choose: false,
							select_show: false,
							select_data: [
								{ name: "单面过光油", value: "过光油" },
								{ name: "单面过哑油", value: "过哑油" },
							],
						},
					],
				},
			]
		}
	}
}
// 专版封套
function createPid_zbft() {
	return {
		p_chengpinchicun: {
			name: '成品尺寸',
			container: ['xx', 'yy', '', 'chichun', 'chichunstr'],
			data: [
				{
					type: 'select', name: 'A4封套-单兜紧凑款（213X300X70mm）', value: [439, 370, '', '439X370mm'], choose: true, select_show: false, select_data: [
						{ name: 'A4封套-单兜紧凑款(213X300X70mm)', value: [439, 370, '(213X305X70mm)'] },
						{ name: 'A4封套-单兜标准款(220X305X70mm)', value: [460, 375, '(220X305X70mm)'] },
						{ name: 'A4封套-双兜标准款(220X305X70mm)', value: [480, 375, '(220X305X70mm)'] },
						{ name: 'A4封套-双兜带书脊(220X305X70X5书脊mm)', value: [485, 375, '(220X305X70X5书脊mm)'] },
					]
				},
				{ type: 'custom3', name: '自定义展开尺寸', value: [486, 378, '', '486*378', '展开尺寸:486*378'], choose: false },
			]
		},

		// 刀模
		p_daomo: {
			name: '刀模',
			container: 'daomo',
			data: [
				{ type: 'default', name: '标准刀模', value: '0', choose: true },
				// { type: 'default', name: '定制刀模', value: '1', choose: false },
			]
		},
		// 材料克重
		p_cailiao: {
			name: '材料',
			container: ['cailiao', 'yongzhi'],
			data_multi: [
				{
					type: 'select', name: '双铜纸', value: '1', choose: true, level: '1', select_show: false, select_data: [
						{ name: '双胶纸', value: '5' },
						{ name: '黄牛皮', value: '9' },
						{ name: '白牛皮', value: '14' },
						{ name: '双铜纸', value: '1' },
						{ name: '单铜纸(白卡)', value: '2' },
						{ name: '哑粉纸', value: '3' },
						{ name: '冰白珠光纸', value: '13' },
					]
				},
				{
					type: 'select', name: '300克', value: 300, choose: true, level: '2', select_show: false, select_data: // 双铜纸
						[
							{ name: '105克', value: 105 },
							// { name: '120克', value: 120 },
							{ name: '128克', value: 128 },
							// { name: '140克', value: 140 },
							// { name: '150克', value: 150 },
							{ name: '157克', value: 157 },
							{ name: '200克', value: 200 },
							// { name: '230克', value: 230 },
							{ name: '250克', value: 250 },
							{ name: '300克', value: 300 },
							{ name: '350克', value: 350 },
							// { name: '400克', value: 400 },
						],
				},
			],
			multi_list: [
				// 双胶纸
				[
					{ name: '100克', value: 100 },
					{ name: '120克', value: 120 },
					{ name: '140克', value: 140 },
					{ name: '160克', value: 160 },
					{ name: '200克', value: 200 },
					{ name: '250克', value: 250 },
				],
				// 黄牛皮
				[
					{ name: '80克', value: 80 },
					{ name: '100克', value: 100 },
					{ name: '120克', value: 120 },
					{ name: '150克', value: 150 },
					{ name: '180克', value: 180 },
					{ name: '200克', value: 200 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
					{ name: '350克', value: 350 },
					{ name: '400克', value: 400 },
				],
				// 白牛皮
				[
					{ name: '100克', value: 100 },
					{ name: '120克', value: 120 },
					{ name: '150克', value: 150 },
					{ name: '180克', value: 180 },
					{ name: '200克', value: 200 },
					{ name: '230克', value: 230 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
				],
				// 双铜纸
				[
					{ name: '105克', value: 105 },
					{ name: '128克', value: 128 },
					{ name: '157克', value: 157 },
					{ name: '200克', value: 200 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
					{ name: '350克', value: 350 },
				],
				// 单铜纸
				[
					{ name: '190克', value: 190 },
					{ name: "210克", value: 210 },
					{ name: "230克", value: 230 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
					{ name: '350克', value: 350 },
				],
				// 哑粉纸
				[
					{ name: '105克', value: 105 },
					{ name: '128克', value: 128 },
					{ name: '157克', value: 157 },
					{ name: '200克', value: 200 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
				],
				// 冰白珠光纸
				[
					{ name: "120克", value: 120 },
					{ name: "140克", value: 140 },
					{ name: "160克", value: 160 },
					{ name: "200克", value: 200 },
					{ name: "250克", value: 250 },
					{ name: "300克", value: 300 },
					{ name: "350克", value: 350 },
				],
			]
		},
		// 单双面
		p_danshuangmian: {
			name: '单双面',
			container: 'danshuang',
			data: [
				{ type: 'default', name: '双面', value: '2', choose: true },
				{ type: 'default', name: '单面', value: '1', choose: false },
			]
		},
		// 印刷颜色
		p_yinshuayanse: {
			name: '印刷颜色',
			container: 'ysys',
			data: [
				{ type: 'default', name: '彩色', value: '4', choose: true },
				{ type: 'default', name: '双色', value: '2', choose: false },
				{ type: 'default', name: '单色', value: '1', choose: false },
				{ type: 'default', name: '无', value: '0', choose: false },
			]
		},
		// 印刷数量
		p_yinshuashuliang: {
			name: '印刷数量',
			container: 'shuliang',
			data: [
				{ type: 'default', name: '500', value: 500, choose: true },
				{ type: 'default', name: '1000', value: 1000, choose: false },
				{ type: 'default', name: '2000', value: 2000, choose: false },
				{ type: 'default', name: '3000', value: 3000, choose: false },
				{ type: 'default', name: '5000', value: 5000, choose: false },
				{ type: 'default', name: '10000', value: 10000, choose: false },
				{ type: 'custom1', name: '自定义', value: 50000, choose: false, },
			]
		},
		// 印刷颜色
		p_yinshuayanse: {
			name: '印刷颜色',
			container: 'ysys',
			data: [
				{ type: 'default', name: '彩色', value: '4', choose: true },
				{ type: 'default', name: '双色', value: '2', choose: false },
				{ type: 'default', name: '单色', value: '1', choose: false },
				{ type: 'default', name: '无', value: '0', choose: false },
			]
		},

		//后道工序
		p_houdaogongxu: {
			name: '后道工序',
			data_after: [
				{
					container: 'hjg',
					must: true,
					data: [
						{ type: 'default', name: '模切', value: '模切', choose: true },
					]
				},
				{
					container: 'hjg',
					must: true,
					data: [
						{ type: 'default', name: '粘单底兜', value: '粘单底兜', choose: true },
						{ type: 'default', name: '粘双底兜', value: '粘双底兜', choose: false },
					]
				},
				{
					container: 'hjg',
					must: false,
					data: [
						{ type: 'default', name: '过光油', value: '过光油', choose: false },
					]
				},
				{
					container: ['tjx', 'tjy', 'hjg'],
					must: false,
					data: [
						{
							type: 'select', custom2: true, unit: 'mm', name: '烫黄金', value: [10, 10, '烫金/银'], choose: false, select_show: false, select_data: [
								{ name: '烫黄金', value: [10, 10, '烫金/银'] },
								{ name: '烫银', value: [10, 10, '烫金/银'] },
								{ name: '烫红金', value: [10, 10, '烫金/银'] },
								{ name: '烫哑金', value: [10, 10, '烫金/银'] },
								{ name: '烫蓝金', value: [10, 10, '烫金/银'] },
								{ name: '烫黑金', value: [10, 10, '烫金/银'] },
								{ name: '烫指定颜色金', value: [10, 10, '烫金/银'] },
							]
						},
					]
				},
				{
					container: ['uvx', 'uvy', 'hjg'],
					must: false,
					data: [
						{ type: 'custom2', name: '局部UV', value: [10, 10, '局部UV'], choose: false },
					]
				},
				{
					container: 'hjg',
					must: false,
					data: [
						{ type: 'default', name: '压纹', value: '压纹', choose: false },
					]
				},
				{
					container: ['jtx', 'jty', 'hjg'],
					must: false,
					data: [
						{ type: 'custom2', name: '击凸', value: [10, 10, '击凸'], choose: false },
					]
				},
				{
					container: 'hjg',
					must: false,
					data: [
						{
							type: 'select', name: '单面亮膜', value: '单面覆亮膜', choose: true, select_show: false, select_data: [
								{ name: '单面亮膜', value: '单面覆亮膜' },
								{ name: '单面哑膜', value: '单面覆哑膜' },
								{ name: '双面亮膜', value: '双面覆亮膜' },
								{ name: '双面哑膜', value: '双面覆哑膜' },
								{ name: '单面防刮花哑膜', value: '31691' },
								{ name: '双面防刮花哑膜', value: '31692' },
							]
						},
					]
				},
			]
		}
	}
}

// 电脑打印联单
function createPid_pcliandan() {
	return {
		// 成品尺寸
		p_chengpinchicun: {
			name: '成品规格',
			container: ['xx', 'yy', 'chichunstr'],
			data: [
				{
					type: 'select', name: '241*140mm', value: [241, 140, '241*140mm'], choose: true, select_show: false, select_data: [
						{ name: '190*127mm', value: [190, 127, '190*127mm'] },
						{ name: '210*127mm', value: [210, 127, '210*127mm'] },
						{ name: '210*140mm', value: [210, 140, '210*140mm'] },
						{ name: '230*140mm', value: [230, 140, '230*140mm'] },
						{ name: '241*127mm', value: [241, 127, '241*127mm'] },
						{ name: '241*140mm', value: [241, 140, '241*140mm'] },
					]
				},
			],
		},
		// 刀模
		p_daomo: {
			name: '联数',
			container: 'lianshu',
			data: [
				{ type: 'default', name: '二联(2000份/箱)', value: '二联', choose: true },
				{ type: 'default', name: '三联(1330份/箱)', value: '三联', choose: false },
				{ type: 'default', name: '四联(1000份/箱)', value: '四联', choose: false },
				{ type: 'default', name: '五联(800份/箱)', value: '五联', choose: false },
			]
		},

		// 印刷款数
		p_kuanshu: {
			name: '款数',
			container: 'pinzhong',
			data: [
				{ type: 'default', name: '1', value: 1, choose: true, },
				{ type: 'default', name: '2', value: 2, choose: false, },
				{ type: 'default', name: '3', value: 3, choose: false, },
				{ type: 'default', name: '4', value: 4, choose: false, },
				{ type: 'default', name: '5', value: 5, choose: false, },
				{ type: 'default', name: '6', value: 6, choose: false, },
				{ type: 'default', name: '7', value: 7, choose: false, },
				{ type: 'custom1', name: '', value: 8, choose: false, },
			],
		},
		// 印刷数量
		p_yinshuashuliang: {
			name: '数量',
			container: 'shuliang',
			data: [
				{ type: 'default', name: '5箱', value: 5, choose: true },
				{ type: 'default', name: '10箱', value: 10, choose: false },
				{ type: 'default', name: '20箱', value: 20, choose: false },
				{ type: 'default', name: '50箱', value: 50, choose: false },
				{ type: 'custom1', name: '', value: 50, choose: false, },
			]
		},

	}
}


// 无碳联单
function createPid_wtliandan() {
	return {
		// 成品尺寸
		p_chengpinchicun: {
			name: '规格',
			container: ['xx', 'yy', 'chichunstr'],
			data: [
				{
					type: 'select', name: '正度32开(130x190mm)', value: [130, 190, '正度32开(130x190mm)'], choose: true, select_show: false, select_data: [
						{ name: '正度32开(130x190mm)', value: [130, 190, '正度32开(130x190mm)'] },
						{ name: '正度16开(260x190mm)', value: [260, 190, '正度16开(260x190mm)'] },
						{ name: '正度48开(175x95mm)', value: [175, 95, '正度48开(175x95mm)'] },
						{ name: '正度40开(190x105mm)', value: [190, 105, '正度40开(190x105mm)'] },
						{ name: '正度24开(190x175mm)', value: [190, 175, '正度24开(190x175mm)'] },
						{ name: '大度32开(210x145mm)', value: [210, 145, '大度32开(210x145mm)'] },
						{ name: '大度16开(210x290mm)', value: [210, 290, '大度16开(210x290mm)'] },
						{ name: '大度48开(210x95mm)', value: [210, 95, '大度48开(210x95mm)'] },
					]
				}
			]
		},
		// 刀模
		p_daomo: {
			name: '联数',
			container: 'lianshu',
			data: [
				{ type: 'default', name: '二联', value: '二联', choose: true },
				{ type: 'default', name: '三联', value: '三联', choose: false },
				{ type: 'default', name: '四联', value: '四联', choose: false },
			]
		},

		// 印刷款数
		p_kuanshu: {
			name: '款数',
			container: 'pinzhong',
			data: [
				{ type: 'default', name: '1', value: 1, choose: true, },
				{ type: 'default', name: '2', value: 2, choose: false, },
				{ type: 'default', name: '3', value: 3, choose: false, },
				{ type: 'default', name: '4', value: 4, choose: false, },
				{ type: 'default', name: '5', value: 5, choose: false, },
				{ type: 'default', name: '6', value: 6, choose: false, },
				{ type: 'default', name: '7', value: 7, choose: false, },
				{ type: 'custom1', name: '', value: 8, choose: false, },
			],
		},
		// 印刷数量
		p_yinshuashuliang: {
			name: '数量',
			container: 'shuliang',
			data: [
				{ type: 'default', name: '50本', value: 50, choose: true },
				{ type: 'default', name: '100本', value: 100, choose: false },
				{ type: 'default', name: '1000本', value: 1000, choose: false },
				{ type: 'custom1', name: '', value: 1000, choose: false, },
			]
		},
		// 印刷颜色
		p_yinshuayanse: {
			name: '颜色',
			container: 'ysys',
			data: [
				{ type: 'default', name: '单黑', value: '0', choose: true },
				{ type: 'default', name: '单红', value: '1', choose: false },
				{ type: 'default', name: '其他颜色', value: '2', choose: false },
			]
		},

		//后道工序
		p_houdaogongxu: {
			name: '后道工序',
			data_after: [
				{
					container: 'hjg',
					must: false,
					data: [
						{ type: 'default', name: '垫纸板', value: '垫纸板', choose: false },
					]
				},
				{
					container: 'hjg',
					must: false,
					data: [
						{ type: 'default', name: '打针孔', value: '打针孔', choose: false },
					]
				},
				{
					container: 'hjg',
					must: false,
					data: [
						{ type: 'default', name: '印反面', value: '印反面', choose: false },
					]
				},
				{
					container: 'hjg',
					must: false,
					data: [
						{ type: 'default', name: '联根字分开', value: '联根字分开', choose: false },
					]
				},
				{
					container: 'hjg',
					must: false,
					data: [
						{ type: 'default', name: '加印1色', value: '加印1色', choose: false },
						{ type: 'default', name: '加印2色', value: '加印2色', choose: false },
						{ type: 'default', name: '加印3色', value: '加印3色', choose: false },
					]
				},

			]
		}
	}


}

//便签表格
function createPid_bzbg() {
	return {
		// 材料
		p_chengpinchicun: {
			name: '规格',
			container: ['xx', 'yy', 'chichunstr'],
			data: [
				{
					type: 'select', name: '正度32开(130x190mm)', value: [130, 190, '正度32开(130x190mm)'], choose: true, select_show: false, select_data: [
						{ name: '正度32开(130x190mm)', value: [130, 190, '正度32开(130x190mm)'] },
						{ name: '正度16开(260x190mm)', value: [260, 190, '正度16开(260x190mm)'] },
						{ name: '正度48开(175x95mm)', value: [175, 95, '正度48开(175x95mm)'] },
						{ name: '正度40开(190x105mm)', value: [190, 105, '正度40开(190x105mm)'] },
						{ name: '正度24开(190x175mm)', value: [190, 175, '正度24开(190x175mm)'] },
						{ name: '大度32开(210x145mm)', value: [210, 145, '大度32开(210x145mm)'] },
						{ name: '大度16开(210x290mm)', value: [210, 290, '大度16开(210x290mm)'] },
						{ name: '大度48开(210x95mm)', value: [210, 95, '大度48开(210x95mm)'] },
					]
				},
			],
		},

		// 材料
		p_cailiao: {
			name: '材料',
			container: 'cailiao',
			data: [
				{ type: 'default', name: '60克双胶纸', value: '60克双胶纸', choose: true, },
				{ type: 'default', name: '70克双胶纸', value: '70克双胶纸', choose: false, },
				{ type: 'default', name: '80克双胶纸', value: '80克双胶纸', choose: false, },
			],
		},
		// 数量
		p_shuliang: {
			name: '数量',
			container: 'shuliang',
			data: [
				{ type: 'default', name: '50', value: 50, choose: true },
				{ type: 'default', name: '100', value: 100, choose: false },
				{ type: 'default', name: '1000', value: 1000, choose: false },
				{ type: 'custom1', name: '', value: 1000, choose: false, },
			]
		},
		// 印刷颜色
		p_yinshuayanse: {
			name: '颜色',
			container: 'ysys',
			data: [
				{ type: 'default', name: '单黑', value: '0', choose: true },
				{ type: 'default', name: '单红', value: '1', choose: false },
				{ type: 'default', name: '其他颜色', value: '2', choose: false },
			]
		},

	}
}
//标准档案盒
function createPid_bzdah() {
	return {
		p_chengpinchicun: {
			name: '成品尺寸',
			container: ['xx', 'yy', 'chichun1', 'isdiy'],
			data: [
				{
					type: 'select', name: '体检报告封面(213X297X3书脊mm)', value: [465, 297, '(210X297X40X5书脊mm)'], src: require("@/assets/banner/tjbgfeng.jpg"), choose: true, select_show: false, select_data: [
						{ name: '体检报告封面(213X297X3书脊mm)', value: [465, 297, '(210X297X40X5书脊mm)'], src: require("@/assets/banner/tjbgfeng.jpg") },
						{ name: '体检报告封面开窗款(213X297X3书脊mm)', value: [465, 297, '(210X297X40X5书脊mm)'], src: require("@/assets/banner/tjbgchuang.jpg") },
						{ name: '体检报告袋竖版(229X324X33mm)', value: [482, 375, '(229X324X33mm)'], src: require("@/assets/banner/tjbgshu.jpg") },
						{ name: '体检报告袋横版(324X229X45mm)', value: [485, 360, '(324X229X45mm)'], src: require("@/assets/banner/tjbgheng.jpg") },
					],
				},
				// { type: 'default', name: '213*290', value: [436, 340, '213*290', ''], choose: true },
				// { type: 'default', name: '213*305', value: [436, 380, '213*305', ''], choose: false },
				{ type: 'custom2', name: '自定义展开尺寸', value: [436, 380, '213*305', '1'], choose: false },
			]
		},

		// 单双面
		p_danshuangmian: {
			name: '单双面',
			container: 'danshuang',
			data: [
				{ type: 'default', name: '双面', value: '2', choose: true },
				{ type: 'default', name: '单面', value: '1', choose: false },
			]
		},
		// 刀模
		p_daomo: {
			name: '刀模',
			container: 'daomo',
			data: [
				{ type: 'default', name: '标准刀模', value: '0', choose: true },
				// { type: 'default', name: '定制刀模', value: '1', choose: false },
			]
		},
		// 材料克重
		p_cailiao: {
			name: '材料',
			container: ['cailiao', 'yongzhi'],
			data_multi: [
				{
					type: 'select', name: '单铜纸(白卡)', value: '2', choose: true, level: '1', select_show: false, select_data: [
						{ name: '双胶纸', value: '5' },
						{ name: '黄牛皮', value: '9' },
						{ name: '白牛皮', value: '14' },
						{ name: '双铜纸', value: '1' },
						{ name: '单铜纸(白卡)', value: '2' },
						{ name: '灰底白(白板)', value: '6' },
						{ name: '哑粉纸', value: '3' },
						// { name: '冰白珠光纸', value: '13' },
					]
				},
				{
					type: 'select', name: '250克', value: 250, choose: true, level: '2', select_show: false, select_data: [
						{ name: '190克', value: 190 },
						{ name: "210克", value: 210 },
						{ name: "230克", value: 230 },
						{ name: '250克', value: 250 },
						{ name: '300克', value: 300 },
						{ name: '350克', value: 350 },
					]
				},
			],
			multi_list: [
				// 双胶纸
				[
					{ name: '100克', value: 100 },
					{ name: '120克', value: 120 },
					{ name: '140克', value: 140 },
					{ name: '160克', value: 160 },
					{ name: '200克', value: 200 },
					{ name: '250克', value: 250 },
				],
				// 黄牛皮
				[
					{ name: '80克', value: 80 },
					{ name: '100克', value: 100 },
					{ name: '120克', value: 120 },
					{ name: '150克', value: 150 },
					{ name: '180克', value: 180 },
					{ name: '200克', value: 200 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
					{ name: '350克', value: 350 },
					{ name: '400克', value: 400 },
				],
				// 白牛皮
				[
					{ name: '100克', value: 100 },
					{ name: '120克', value: 120 },
					{ name: '150克', value: 150 },
					{ name: '180克', value: 180 },
					{ name: '200克', value: 200 },
					{ name: '230克', value: 230 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
				],
				// 双铜纸
				[
					{ name: '105克', value: 105 },
					// { name: '120克', value: 120 },
					{ name: '128克', value: 128 },
					// { name: '140克', value: 140 },
					// { name: '150克', value: 150 },
					{ name: '157克', value: 157 },
					{ name: '200克', value: 200 },
					// { name: '230克', value: 230 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
					{ name: '350克', value: 350 },
					// { name: '400克', value: 400 },
				],
				// 单铜纸
				[
					{ name: '190克', value: 190 },
					{ name: "210克", value: 210 },
					{ name: "230克", value: 230 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
					{ name: '350克', value: 350 },
				],
				// 灰底白(白板)
				[
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
					{ name: '350克', value: 350 },
					{ name: '400克', value: 400 },
				],
				// 哑粉纸
				[
					{ name: '105克', value: 105 },
					{ name: '128克', value: 128 },
					{ name: '157克', value: 157 },
					{ name: '200克', value: 200 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
				],
			]
		},
		// 印刷颜色
		p_yinshuayanse: {
			name: '印刷颜色',
			container: 'ysys',
			data: [
				{ type: 'default', name: '彩色', value: '4', choose: true },
				{ type: 'default', name: '双色', value: '2', choose: false },
				{ type: 'default', name: '单色', value: '1', choose: false },
				{ type: 'default', name: '无', value: '0', choose: false },
			]
		},
		// 印刷数量
		p_yinshuashuliang: {
			name: '印刷数量',
			container: 'shuliang',
			data: [
				{ type: 'default', name: '500', value: 500, choose: true },
				{ type: 'default', name: '1000', value: 1000, choose: false },
				{ type: 'default', name: '2000', value: 2000, choose: false },
				{ type: 'default', name: '3000', value: 3000, choose: false },
				{ type: 'default', name: '5000', value: 5000, choose: false },
				{ type: 'default', name: '10000', value: 10000, choose: false },
				{ type: 'custom1', name: '自定义', value: 50000, choose: false, },
			]
		},
		//后道工序
		p_houdaogongxu: {
			name: '后道工序',
			data_after: [
				{
					container: 'hjg',
					must: true,
					data: [
						{ type: 'default', name: '模切', value: '模切', choose: true },
					]
				},
                {
					container: 'hjgzdy4',
					must: false,
					data: [
						{
							type: 'select', name: '贴双面胶和易撕带', value: '13669', choose: true, select_show: false, select_data: [
								{ name: '贴双面胶和易撕带', value: '13669' },
								{ name: '贴离型胶和易撕带', value: '31686' },
							]
						},
					]
				},
				{
					container: 'hjgzdy5',
					must: false,
					data: [
						{ type: 'default', name: '加装订胶条', value: '15233', choose: true },
					]
				},
				{
					container: 'hjgzdy3',
					must: false,
					data: [
						{ type: 'default', name: '粘成品', value: '5781', choose: false },
					]
				},
				{
					container: 'hjgzdy1',
					must: false,
					data: [
						{ type: 'default', name: '贴双面胶', value: '5778', choose: false },
					]
				},
				{
					container: 'hjgzdy2',
					must: false,
					data: [
						{ type: 'default', name: '贴易撕带', value: '5780', choose: false },
					]
				},
				// {
				// 	container: 'hjgzdy6',
				// 	must: false,
				// 	data: [
				// 		{ type: 'default', name: '粘单底兜', value: '15400', choose: false },
				// 	]
				// },
				// {
				// 	container: 'hjgzdy7',
				// 	must: false,
				// 	data: [
				// 		{ type: 'default', name: '粘双底兜', value: '15401', choose: false },
				// 	]
				// },
				{
					container: 'hjg',
					must: false,
					data: [
						{ type: 'default', name: '过光油', value: '过光油', choose: false },
					]
				},
				{
					container: ['tjx', 'tjy', 'hjg'],
					must: false,
					data: [
						{
							type: 'select', custom2: true, unit: 'mm', name: '烫黄金', value: [10, 10, '烫金/银'], choose: false, select_show: false, select_data: [
								{ name: '烫黄金', value: [10, 10, '烫金/银'] },
								{ name: '烫银', value: [10, 10, '烫金/银'] },
								{ name: '烫红金', value: [10, 10, '烫金/银'] },
								{ name: '烫哑金', value: [10, 10, '烫金/银'] },
								{ name: '烫蓝金', value: [10, 10, '烫金/银'] },
								{ name: '烫黑金', value: [10, 10, '烫金/银'] },
								{ name: '烫指定颜色金', value: [10, 10, '烫金/银'] },
							]
						},
					]
				},
				{
					container: ['uvx', 'uvy', 'hjg'],
					must: false,
					data: [
						{ type: 'custom2', name: '局部UV', value: [10, 10, '局部UV'], choose: false },
					]
				},
				{
					container: 'hjg',
					must: false,
					data: [
						{ type: 'default', name: '压纹', value: '压纹', choose: false },
					]
				},
				{
					container: ['jtx', 'jty', 'hjg'],
					must: false,
					data: [
						{ type: 'custom2', name: '击凸', value: [10, 10, '击凸'], choose: false },
					]
				},
				{
					container: 'hjg',
					must: false,
					data: [
						{
							type: 'select', name: '单面亮膜', value: '单面覆亮膜', choose: false, select_show: false, select_data: [
								{ name: '单面亮膜', value: '单面覆亮膜' },
								{ name: '单面哑膜', value: '单面覆哑膜' },
								{ name: '双面亮膜', value: '双面覆亮膜' },
								{ name: '双面哑膜', value: '双面覆哑膜' },
								{ name: '单面防刮花哑膜', value: '31687' },
								{ name: '双面防刮花哑膜', value: '31688' },
							]
						},
					]
				},
				{
					container: ["texthjgzdyx13", "texthjgzdyy13",  'hjgzdy13'],
					must: false,
					data: [
						{ type: 'custom2', name: '开窗贴8丝PVC', value: [90, 50, '47087'], choose: false },
					]
				},
			]
		}
	}
}
// 快递封
function createPid_kuaidifeng() {
	return {
		// 成品尺寸
		p_chengpinchicun: {
			name: '成品尺寸',
			container: ['xx', 'yy', 'chichunstr'],
			data: [
				{
					type: 'select', name: '小号(250x180mm)', value: [286, 387, '小号(250x180mm)'], choose: true, select_show: false, select_data: [
						{ name: '小号(250x180mm)', value: [286, 387, '小号(250x180mm)'] },
						{ name: '中号(324x229mm)', value: [360, 485, '中号(324x229mm)'] },
						{ name: '大号(350x250mm)', value: [386, 530, '大号(350x250mm)'] },
					]
				},
				{ type: 'custom2', name: '自定义展开尺寸', value: [386, 530, '386x530'], choose: false }
			]
		},
		// 刀模
		p_daomo: {
			name: '刀模',
			container: 'daomo',
			data: [
				{ type: 'default', name: '标准刀模', value: '0', choose: true },
				// { type: 'default', name: '定制刀模', value: '1', choose: false },
			]
		},
		// 材料
		p_cailiao: {
			name: '材料',
			container: ['cailiao', 'yongzhi'],
			data_multi: [
				{
					type: 'select', name: '白板(灰底白)', value: '6', choose: true, level: '1', select_show: false, select_data: [
						{ name: '白板(灰底白)', value: '6' },
						{ name: '单铜纸(白卡)', value: '2' },
					]
				},
				{
					type: 'select', name: '250克', value: 250, choose: true, level: '2', select_show: false, select_data: [
						{ name: '250克', value: 250 },
						{ name: '300克', value: 300 },
					]
				},
			],
			multi_list: [
				// 白板(灰底白)
				[
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
				],
				// 单铜纸
				[
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
				],
			]
		},
		// 印刷数量
		p_yinshuashuliang: {
			name: '印刷数量',
			container: 'shuliang',
			data: [
				{ type: 'default', name: '500', value: 500, choose: true },
				{ type: 'default', name: '1000', value: 1000, choose: false },
				{ type: 'default', name: '2000', value: 2000, choose: false },
				{ type: 'default', name: '5000', value: 5000, choose: false },
				{ type: 'default', name: '10000', value: 10000, choose: false },
				{ type: 'default', name: '50000', value: 50000, choose: false },
				{ type: 'custom1', name: '自定义', value: 50000, choose: false, },
			]
		},
		// 印刷颜色
		p_yinshuayanse: {
			name: '印刷颜色',
			container: 'ysys',
			data: [
				{ type: 'default', name: '彩色', value: '4', choose: true },
			]
		},
		//后道工序
		p_houdaogongxu: {
			name: '后道工序',
			data_after: [
				{
					container: 'hjgzdy0',
					must: false,
					data: [
						{ type: 'default', name: '过光油', value: '5777', choose: true },
					]
				},
				{
					container: 'hjg',
					must: true,
					reduce: true,//缩小排放
					data: [
						{ type: 'default', name: '模切', value: '模切', choose: true },
					]
				},
				{
					container: 'hjgzdy4',
					must: false,
					data: [
						{
							type: 'select', name: '贴双面胶和易撕带', value: '13669', choose: true, select_show: false, select_data: [
								{ name: '贴双面胶和易撕带', value: '13669' },
								{ name: '贴离型胶和易撕带', value: '31686' },
							]
						},
					]
				},
				{
					container: 'hjgzdy3',
					must: true,
					data: [
						{ type: 'default', name: '粘成品', value: '5781', choose: true },
					]
				},
				{
					container: 'hjgzdy1',
					must: false,
					data: [
						{ type: 'default', name: '贴双面胶', value: '5778', choose: false },
					]
				},
				{
					container: 'hjgzdy2',
					must: false,
					data: [
						{ type: 'default', name: '贴易撕带', value: '5780', choose: false },
					]
				},
				{
					container: ['tjx', 'tjy', 'hjg'],
					must: false,
					data: [
						{
							type: 'select', custom2: true, unit: 'mm', name: '烫黄金', value: [10, 10, '烫金/银'], choose: false, select_show: false, select_data: [
								{ name: '烫黄金', value: [10, 10, '烫金/银'] },
								{ name: '烫银', value: [10, 10, '烫金/银'] },
								{ name: '烫红金', value: [10, 10, '烫金/银'] },
								{ name: '烫哑金', value: [10, 10, '烫金/银'] },
								{ name: '烫蓝金', value: [10, 10, '烫金/银'] },
								{ name: '烫黑金', value: [10, 10, '烫金/银'] },
								{ name: '烫指定颜色金', value: [10, 10, '烫金/银'] },
							]
						},
					]
				},
				{
					container: ['uvx', 'uvy', 'hjg'],
					must: false,
					data: [
						{ type: 'custom2', name: '局部UV', value: [10, 10, '局部UV'], choose: false },
					]
				},
				{
					container: 'hjg',
					must: false,
					data: [
						{ type: 'default', name: '压纹', value: '压纹', choose: false },
					]
				},
				{
					container: ['jtx', 'jty', 'hjg'],
					must: false,
					data: [
						{ type: 'custom2', name: '击凸', value: [10, 10, '击凸'], choose: false },
					]
				},
				{
					container: 'hjgzdy11',
					must: false,
					data: [
						{
							type: 'select', name: '单面亮膜', value: '单面覆亮膜', choose: false, select_show: false, select_data: [
								{ name: '单面亮膜', value: '单面覆亮膜' },
								{ name: '单面哑膜', value: '单面覆哑膜' },
								{ name: '单面防刮花哑膜', value: '31687' },
							]
						},
					]
				},
			]
		}
	}
}
//会计用品
function createPid_kjyp() {
	return {
		// 产品名
		p_leixing: {
			name: '产品类型',
			container: 'leixing',
			data: [
				{ type: 'default', name: '会计凭证', value: '会计凭证', choose: true, },
				{ type: 'default', name: '档案盒', value: '档案盒', choose: false, },
			]
		},
		p_pinming: {
			name: '品名',
			container: 'pinming',
			data: [
				{ type: 'default', name: '会计凭证盒(横版)', value: '会计凭证盒(横版)', choose: true, },
				{ type: 'default', name: '会计凭证盒(竖版)', value: '会计凭证盒(竖版)', choose: false, },
				{ type: 'default', name: '会计凭证封面(横版)', value: '会计凭证封面(横版)', choose: false, },
				{ type: 'default', name: '会计凭证封面(竖版)', value: '会计凭证封面(竖版)', choose: false, },
			],
		},

		// 规格
		p_guige: {
			name: '规格',
			container: ['xx', 'yy', 'chichunstr'],
			data: [
				{ type: 'default', name: '305x220x40mm', value: [305, 220, '305x220x40mm'], choose: true, },
				{ type: 'default', name: '305x220x50mm', value: [305, 220, '305x220x50mm'], choose: false, },
			],
		},
		// 材料
		p_cailiao: {
			name: '材质',
			container: 'cailiao',
			data: [
				{ type: 'default', name: '国产680克无酸纸', value: '国产680克无酸纸', choose: true, },
				{ type: 'default', name: '进口700克牛皮纸', value: '进口700克牛皮纸', choose: false, },

			],
		},
		// 包装单位
		p_danwei: {
			name: '包装单位',
			container: 'danwei',
			data: [
				{ type: 'default', name: '个', value: '个', choose: true, },

			],
		},
		//数量
		p_yinshuashuliang: {
			name: '数量',
			container: 'shuliang',
			data: [
				{ type: 'default', name: '100', value: 100, choose: true },
				{ type: 'custom1', name: '自定义', value: 100, choose: false, },
			]
		},
		//定制印刷
		p_dingzhiyinshua: {
			name: '定制印刷',
			data_after: [
				{
					container: 'hjg',
					must: false,
					data: [
						{ type: 'default', name: '定制印刷', value: '定制印刷', choose: false },
					]
				},
			]
		}

	}
}
//高端烫印
function createPid_gdty() {
	return {

		p_chengpinchicun: {
			name: '成品尺寸',
			container: ['xx', 'yy', 'chichunstr'],
			data: [
				// { type: 'default', name: '5号西式信封', value: [252, 256, '5号西式信封'], choose: true },
				{
					type: 'select', name: '5号西式信封', value: [252, 256, '5号烫印'], choose: true, select_show: false, select_data: [
						{ name: '1号信封', value: [207, 233, '1号烫印'] },
						{ name: '2号信封', value: [207, 233, '2号烫印'] },
						{ name: '3号信封', value: [210, 270, '3号烫印'] },
						{ name: '5号信封', value: [252, 256, '5号烫印'] },
						{ name: '6号信封', value: [260, 260, '6号烫印'] },
						{ name: '7号信封', value: [265, 350, '7号烫印'] },
						{ name: '8号信封', value: [282, 375, '8号烫印'] },
						{ name: '9号信封', value: [370, 480, '9号烫印'] },
					]
				},
			]
		},
		p_daomo: {
			name: '刀模',
			container: 'daomo',
			data: [
				{ type: 'default', name: '西式尖舌带插口', value: '西式尖舌带插口', choose: true, },
			]
		},
		// 材料
		p_cailiao: {
			name: '纸张',
			container: 'cailiao',
			data: [
				{ type: 'default', name: '250克珠光纸', value: '250克原浆珠光纸', choose: true, },
			],
		},
		//纸张颜色
		p_color: {
			name: '纸张颜色',
			container: 'color',
			data: [
				{ type: 'default', name: '深宝兰', value: '深宝兰', choose: true, },
				{ type: 'default', name: '湖兰', value: '湖兰', choose: false, },
				{ type: 'default', name: '宝兰', value: '宝兰', choose: false, },
				{ type: 'default', name: '天兰', value: '天兰', choose: false, },
				{ type: 'default', name: '粉兰', value: '粉兰', choose: false, },
				{ type: 'default', name: '浅兰2号', value: '浅兰2号', choose: false, },
				{ type: 'default', name: '碳黑', value: '碳黑', choose: false, },
				{ type: 'default', name: '浅绿', value: '浅绿', choose: false, },
				{ type: 'default', name: '珠白', value: '珠白', choose: false, },
				{ type: 'default', name: '白金', value: '白金', choose: false, },
				{ type: 'default', name: '浅红', value: '浅红', choose: false, },
				{ type: 'default', name: '橙色', value: '橙色', choose: false, },
				{ type: 'default', name: '酒红', value: '酒红', choose: false, },
				{ type: 'default', name: '紫红', value: '紫红', choose: false, },
				{ type: 'default', name: '咖啡', value: '咖啡', choose: false, },
				{ type: 'default', name: '银白', value: '银白', choose: false, },
				{ type: 'default', name: '艳紫', value: '艳紫', choose: false, },
				{ type: 'default', name: '银灰', value: '银灰', choose: false, },
				{ type: 'default', name: '星翠', value: '星翠', choose: false, },
				{ type: 'default', name: '粉红', value: '粉红', choose: false, },
				{ type: 'default', name: '冰白', value: '冰白', choose: false, },
				{ type: 'default', name: '金黄', value: '金黄', choose: false, },
				{ type: 'default', name: '金铜', value: '金铜', choose: false, },
				{ type: 'default', name: '米金', value: '米金', choose: false, },
				{ type: 'default', name: '古铜', value: '古铜', choose: false, },
				{ type: 'default', name: '紫色', value: '紫色', choose: false, },
				{ type: 'default', name: '墨绿', value: '墨绿', choose: false, },
			],
		},
		//烫金颜色
		p_tangjin: {
			name: '烫金颜色',
			container: 'tangjin',
			data: [
				{
					type: 'select', name: '烫黄金', value: '烫黄金', choose: true, select_show: false, select_data: [
						{ name: '烫黄金', value: '烫黄金' },
						{ name: '烫银', value: '烫银' },
						{ name: '烫红金', value: '烫红金' },
						{ name: '烫哑金', value: '烫哑金' },
						{ name: '烫蓝金', value: '烫蓝金' },
						{ name: '烫黑金', value: '烫黒金' },
					]
				},
			],
		},
		// 数量
		p_yinshuashuliang: {
			name: '数量(个)',
			container: 'shuliang',
			data: [
				{ type: 'default', name: '100', value: 100, choose: true },
				{ type: 'default', name: '200', value: 200, choose: false },
				{ type: 'default', name: '300', value: 300, choose: false },
				{ type: 'default', name: '500', value: 500, choose: false },
				{ type: 'default', name: '1000', value: 1000, choose: false },
				{ type: 'default', name: '2000', value: 2000, choose: false },
				{ type: 'default', name: '3000', value: 3000, choose: false },
				{ type: 'default', name: '5000', value: 5000, choose: false },
				{ type: 'custom1', name: '', value: 10000, choose: false, },
			]
		},
	}

}



// WEBPACK FOOTER //
// ./src/seal/proCardSet.js